import React, { Fragment } from 'react'
import IntroItem from './IntroItem'

const Intro = ({ intro }) => {
    return (
        <Fragment>
            <div className="bottom-line"></div>
            { intro && intro.map(intro => <IntroItem key={intro._id} intro={intro}/>) }
        </Fragment>
    )
}

export default Intro
